import React, { useState, createContext } from 'react'

export default () => {}

export const GeneralAppStorageContext = createContext()

export function GeneralAppStorageContextProvider({ children }) {
  const generalAppStorageValue = useGeneralAppStorageContextController()
  return (
    <GeneralAppStorageContext.Provider value={generalAppStorageValue}>{children}</GeneralAppStorageContext.Provider>
  )
}

export function useGeneralAppStorageContextController() {
  const [queuesCacheList, setQueuesCacheList] = useState([])

  // putting all state together makes debugging easier because you can see the state with RawData
  const appStorageState = {
    queuesCacheList,
  }

  // putting all functions together
  const appStorageActions = {
    addMessageToQueuesCache: (message) => {
      // adds the message at the beginning of the list so that newer items are at the top in the UI
      queuesCacheList.unshift(message)
      queuesCacheList.length = Math.min(queuesCacheList.length, 10)
      setQueuesCacheList(queuesCacheList)
      return Promise.resolve()
    },
  }

  return { appStorageState, appStorageActions }
}
